import { GenericAbortSignal } from 'axios';

import { DenialListItem } from 'models/DenialListItem';
import { Paginated } from 'models/Paginated';
import { BaseIndexQueryParams } from 'services/api/types';
import http from 'services/http';

export type DenialListItemsIndexParams = BaseIndexQueryParams;

export const denialListItemQueryKeys = {
  base: ['denialListItems'],
  index: (params: Record<string, any> = {}) => ['denialListItems', 'index', params],
};

export async function indexDenialListItems(params: DenialListItemsIndexParams, signal: GenericAbortSignal) {
  return http
    .get<Paginated<DenialListItem>>('/denial_list_items', { params, signal })
    .then((response) => response.data);
}
